import React from "react";
import { TIMELINE_OPTIONS, SERVICE_OPTIONS, CONTACT_METHODS } from "@/lib/site";

export function NameAndPhone({ data, update }) {
  return (
    <div className="grid sm:grid-cols-2 gap-3">
      <div>
        <label className="label-br">Name *</label>
        <input className="input-br" value={data.name} onChange={update("name")} required data-testid="input-name" />
      </div>
      <div>
        <label className="label-br">Phone *</label>
        <input className="input-br" value={data.phone} onChange={update("phone")} required data-testid="input-phone" />
      </div>
    </div>
  );
}

export function EmailField({ data, update }) {
  return (
    <div>
      <label className="label-br">Email *</label>
      <input type="email" className="input-br" value={data.email} onChange={update("email")} required data-testid="input-email" />
    </div>
  );
}

export function AddressField({ data, update }) {
  return (
    <div>
      <label className="label-br">Property Address or Service Area</label>
      <input className="input-br" value={data.address} onChange={update("address")} placeholder="e.g. Round Rock, TX" data-testid="input-address" />
    </div>
  );
}

export function ServiceAndTimeline({ data, update, showTimeline = true }) {
  return (
    <div className="grid sm:grid-cols-2 gap-3">
      <div>
        <label className="label-br">Service Needed</label>
        <select className="select-br" value={data.service} onChange={update("service")} data-testid="input-service">
          <option value="">Select a service</option>
          {SERVICE_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      {showTimeline && (
        <div>
          <label className="label-br">Project Timeline</label>
          <select className="select-br" value={data.timeline} onChange={update("timeline")} data-testid="input-timeline">
            <option value="">Select timeline</option>
            {TIMELINE_OPTIONS.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      )}
    </div>
  );
}

export function MessageField({ data, update, rows = 4 }) {
  return (
    <div>
      <label className="label-br">Project Details / Message</label>
      <textarea rows={rows} className="textarea-br" value={data.message} onChange={update("message")} placeholder="Tell us a bit about what you need." data-testid="input-message" />
    </div>
  );
}

export function PreferredContactPicker({ data, update }) {
  return (
    <div>
      <label className="label-br">Preferred Contact Method</label>
      <div className="flex gap-3 flex-wrap">
        {CONTACT_METHODS.map((m) => (
          <label key={m} className={`px-3 py-2 border rounded text-xs uppercase tracking-wider cursor-pointer ${data.preferred_contact === m ? "bg-br-bronze text-white border-br-bronze" : "bg-white border-gray-300 text-gray-700 hover:border-br-bronze"}`}>
            <input type="radio" name="pref" value={m} checked={data.preferred_contact === m} onChange={update("preferred_contact")} className="hidden" />
            {m}
          </label>
        ))}
      </div>
    </div>
  );
}

export function HoneypotField({ data, update }) {
  return (
    <input type="text" name="website" value={data.website} onChange={update("website")} className="hidden" tabIndex={-1} autoComplete="off" />
  );
}
